import { useState, useEffect } from "react";
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import PropTypes from "prop-types";

import OrganismInfo from "./OrganismInfo";
import { setAllOrganisms } from "../../../redux/reducers/organismsReducer";
import { useDispatch } from "react-redux";

// Remplacez par vos propres appels à l'API
import { getOrganisms, postOrganism, putOrganism } from "../../../api/organisms";

export default function CreateEditOrganism({
  organisms,
  setOrganisms,
  organism = null,
  edit = false,
}) {
  const [open, setOpen] = useState(false);

  const [organismId, setOrganismId] = useState("");
  const [organismName, setOrganismName] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (edit && organism) {
      setOrganismId(organism.organism_id);
      setOrganismName(organism.organism_name);
    }
  }, [edit, organism]);

  async function createOrganismAPI() {
    const organism = {
      organism_name: organismName,
    };
    await postOrganism(organism);
  }

  async function updateOrganismAPI() {
    const organism = {
      organism_name: organismName,
    };
    await putOrganism(organism, organismId);
  }

  function resetData() {
    setOrganismId("");
    setOrganismName("");
  }

  async function fetchOrganisms() {
    const response = await getOrganisms();
    setOrganisms(response.data);
    const formatedOrganisms = await response.data.map((organism) => ({
      label: organism.organism_name,
      id: organism.organism_id,
    }));
    dispatch(setAllOrganisms(formatedOrganisms));
  }

  async function submit() {
    if (edit) {
      await updateOrganismAPI();
      await fetchOrganisms();
    } else {
      await createOrganismAPI();
      await fetchOrganisms();
      resetData();
    }
    setOpen(false);
  }

  async function cancel() {
    if (edit) {
      await fetchOrganisms();
    } else {
      resetData();
    }
    setOpen(false);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      {edit ? (
        <MDButton
          variant="contained"
          size="small"
          onClick={() => setOpen(true)}
          color={darkMode ? "white" : "dark"}
          sx={{
            width: 170,
            padding: "6px 0 !important",
            height: 40,
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
        >
          Gérer l'organisme
        </MDButton>
      ) : (
        <MDButton
          variant="contained"
          sx={{
            height: 53.13,
            width: "100%",
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
          color={darkMode ? "white" : "dark"}
          size="large"
          onClick={() => setOpen(true)}
        >
          Ajouter un organisme
        </MDButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card>
                <MDBox
                  mt={-5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  sx={{
                    background: darkMode ? "white" : "linear-gradient(195deg, #364c70, #273956)",
                    boxShadow: darkMode ? "0 1px 6px 1px white" : "0 1px 6px 1px #344767",
                  }}
                  borderRadius="lg"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={1}>
                    <MDBox>
                      {edit ? (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Modification de l'organisme
                        </MDTypography>
                      ) : (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Ajout d'un nouvel organisme
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      color={darkMode ? "inherit" : "white"}
                    >
                      Veuillez entrer les informations relatives au nouvel organisme
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox>
                    <OrganismInfo organismName={organismName} setOrganismName={setOrganismName} />
                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                      <MDBox />
                      <MDBox textAlign="right">
                        <Grid container spacing={1.5}>
                          <Grid item>
                            <MDButton
                              variant="gradient"
                              color="warning"
                              onClick={cancel}
                              sx={{ marginRight: 2 }}
                            >
                              Annuler
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton variant="gradient" color="success" onClick={submit}>
                              Envoyer
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

CreateEditOrganism.propTypes = {
  edit: PropTypes.bool.isRequired,
};
